import { Group, ImageVideoSlider, Title } from "components/common";
import { renderQuillHtml } from "configs/utils";
import styles from "./index.module.less";

const ScriptDetailPresentationSection = ({ titleDescription, media }) => {
  return (
    <div className={styles.titleDescription} id={`Presentation`}>
      <Group>
        <div className={styles.sectionTitle}>Presentation</div>
        {titleDescription?.length ? (
          titleDescription?.map((section) => (
            <div>
              <Title className={styles.title} level={4}>
                {section.title}
              </Title>
              <div className={styles.description}>
                {renderQuillHtml(section.description)}
              </div>
            </div>
          ))
        ) : (
          <></>
        )}
        {media?.length ? (
          <ImageVideoSlider dataList={media} width={200} height={125} />
        ) : null}
      </Group>
    </div>
  );
};

export default ScriptDetailPresentationSection;
